import html2canvas from 'html2canvas';
import logo from '../../../images/logo.svg';

const capture = (captureArea, fileName, title, callback, isScrollable) => {
  const scale = 2;
  const _title = title;

  async function generateAllCapture() {
    const captureImages = [];

    for (let i = 0; i < captureArea.length; i++) {
      const area = captureArea[i];
      const hides = area.querySelectorAll('.capture-hide');
      const index = Number(area.dataset.capture) || i;

      hides.forEach(hide => hide.style.visibility = 'hidden');

      const captureOffsetTop = area.getBoundingClientRect().top + window.pageYOffset;
      const captureOffsetLeft = area.getBoundingClientRect().left;

      const canvas = await html2canvas(area, {
        onclone: function (clonedDoc) {
          var elem = clonedDoc.getElementById('info');
          if (elem) {
            elem.style.letterSpacing = '0.5px';
            elem.style.overflow = 'visible !important';
            elem.style.maxHeight = 'none';
            void elem.offsetHeight; // 強制重繪
          }
        },
        x: captureOffsetLeft,
        y: captureOffsetTop,
        width: area.offsetWidth,
        height: isScrollable ? area.scrollHeight : area.offsetHeight,
        scale: scale,
      });

      captureImages[index] = canvas;
    }

    return captureImages;
  }

  generateAllCapture().then(images => {
    const resultCanvas = document.createElement('canvas');
    const context = resultCanvas.getContext('2d');
    const canvasWidth = Math.max(...images.map(image => image.width));
    const canvasHeight = images.map(image => image.height).reduce((sum, value) => sum + value);
    const padding = 40;
    const resultCanvasWidth = canvasWidth + padding * scale;
    const resultCanvasHeight = canvasHeight + padding * scale;

    const bottomLogo = new Image();
    bottomLogo.src = logo;
    const logoWidth = 300 * scale;
    const logoHeight = 50 * scale;

    // 設定標題
    var title = _title;
    var titleFontSize = 24 * scale;
    var titleHeight = titleFontSize + padding;
    if (_title == undefined) { titleHeight = 0; }

    resultCanvas.width = resultCanvasWidth;
    resultCanvas.height = resultCanvasHeight + logoHeight + titleHeight;
    context.fillStyle = "white";
    context.fillRect(0, 0, resultCanvasWidth, resultCanvasHeight + logoHeight + titleHeight);


    // 繪製標題（已註解，標題從截取的元素中取得）
    // context.fillStyle = "black";
    // context.font = `${titleFontSize}px 'Microsoft-JhengHei-Bold', 'Noto Sans CJK', sans-serif`;
    // var titleWidth = context.measureText(title).width;
    // var titleX = (resultCanvasWidth - titleWidth) / 2;
    // context.fillText(title, titleX, padding + titleFontSize);

    bottomLogo.onload = function () {
      context.drawImage(bottomLogo, canvasWidth + padding - logoWidth, canvasHeight + padding + titleHeight, logoWidth, logoHeight);
    };

    let offsetHeight = titleHeight;
    images.forEach((image) => {
      const imgElement = new Image();
      imgElement.src = image.toDataURL('image/png;base64');
      imgElement.onload = function () {
        context.drawImage(imgElement, padding, padding + offsetHeight, imgElement.width, imgElement.height);
        offsetHeight += imgElement.height;
      };
    });

    const resultImage = new Image();
    resultImage.src = resultCanvas.toDataURL('image/png;base64');

    function downloadTrigger() {
      setTimeout(() => {
        if (resultImage.complete) {
          const downloadTrigger = document.createElement('a');
          downloadTrigger.setAttribute('download', `${fileName}.png`);
          downloadTrigger.setAttribute('href', resultCanvas.toDataURL('image/png;base64'));
          downloadTrigger.click();
          downloadTrigger.remove();
          resultCanvas.remove();

          captureArea.forEach(area => {
            const hides = area.querySelectorAll('.capture-hide');
            hides.forEach(hide => hide.style = {});
          })

          callback && callback();
        }
        else {
          downloadTrigger();
        }
      }, 1000);
    }

    downloadTrigger();

  });

};

export default capture;
